<template>
  <div>
    <el-dialog
        title="选择上传方式"
        v-model="bShowChooser"
        custom-class="upload-card"
        @close="$emit('close')"
        width="400px"
    >
      <div style="display: flex; height: 80px;">
        <img style="position:absolute;left:10%; height:60px;" src="./assets/camera.png" v-on:click="selectUpload('camera')"/>
        <img style="position:absolute;left:30%; height:60px;" src="./assets/picture.png" v-on:click="selectUpload('picture')"/>
        <img style="position:absolute;left:50%; height:60px;" src="./assets/pasteboard.png" v-on:click="selectUpload('pasteboard')"/>
      </div>
    </el-dialog>

    <!-- 相机拍照弹窗 -->
    <el-dialog
        title="相机拍摄"
        v-model="cameraVisible"
        custom-class="camera-dialog"
        @close="closeCamera"
        width="600px"
    >
      <div class="camera-container">
        <video style="width: -webkit-fill-available;" ref="video" autoplay></video> <!-- 实时摄像头画面 -->
        <el-button type="primary" @click="capturePhoto">拍照</el-button> <!-- 新增快门按钮 -->
      </div>
    </el-dialog>

    <!-- 裁剪框及上传操作弹窗 -->
    <el-dialog
        title="裁剪图片"
        v-model="cropVisible"
        custom-class="upload-card"
        @close="cropVisible = false"
        width="600px"
    >
      <div class="crop-container">
        <img ref="cropperImage" alt="待裁剪图片" style="max-width: 100%;" />
      </div>
      <div class="crop-actions" style="margin-top: 10px;">
        <el-button type="primary" @click="cropAndUpload">确认</el-button>
        <el-button @click="cancelCrop">{{ $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: "ImageChooser",
  components: {
  },
  data() {
    return {
      bShowChooser: true,
      cropVisible: false,  // 控制裁剪弹窗的显示
      croppedImageSrc: '', // 存储需要裁剪的图片
      cropper: null,       // cropper 实例
      videoStream: null,   // 存储摄像头视频流
      cameraVisible: false, // 控制相机拍照弹窗
    }
  },
  methods: {
    selectUpload: function (type) {
      if (type === 'camera') {
        this.openCamera();
      }
      else if (type === 'picture') {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = (event) => {
          const file = event.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.croppedImageSrc = e.target.result;
              this.openCropper();  // 打开裁剪框
            };
            reader.readAsDataURL(file);
          }
        };
        input.click();
      }
      else if (type === 'pasteboard') {
        // 获取剪贴板图片
        navigator.clipboard.read().then((items) => {
          for (const item of items) {
            if (item.types.includes('image/png') || item.types.includes('image/jpeg')) {
              item.getType('image/png').then((blob) => {
                const file = new File([blob], "pasteboard-image.png", { type: blob.type });
                const reader = new FileReader();
                reader.onload = (e) => this.updateImage(e.target.result, file);
                reader.readAsDataURL(blob);
              });
              break;
            }
          }
        }).catch((error) => {
          console.error("Error accessing clipboard:", error);
        });
      }
    },

    // 打开相机
    openCamera: function() {
      let thiz = this;
      this.cameraVisible = true;
      navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment'  // 使用后置摄像头
        }
      })
          .then((stream) => {
            console.log('stream=',stream);
            console.log('this.$refs.video', thiz.$refs.video);
            thiz.videoStream = stream;
            thiz.$refs.video.srcObject = stream;  // 显示摄像头实时画面
          })
          .catch((error) => {
            console.error("Error accessing camera:", error);
          });
    },

    // 关闭相机
    closeCamera: function() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop());  // 停止摄像头流
        this.videoStream = null;
      }
      this.cameraVisible = false;
    },

    // 拍照并进入裁剪
    capturePhoto: function() {
      const video = this.$refs.video;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // 设置 canvas 尺寸与视频一致
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // 将视频画面绘制到 canvas 上
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageUrl = canvas.toDataURL('image/png');

      // 将图片传给裁剪框
      this.croppedImageSrc = imageUrl;
      this.closeCamera();  // 关闭相机
      this.openCropper();  // 打开裁剪框
    },

    // 打开裁剪区域
    openCropper: function() {
      this.cropVisible = true;
      this.$nextTick(() => {
        const imageElement = this.$refs.cropperImage;
        imageElement.src = this.croppedImageSrc; // 设置裁剪框的图片源
        if (this.cropper) {
          this.cropper.destroy();
        }
        this.cropper = new Cropper(imageElement, {
          viewMode: 1,
        });
      });
    },

    // 裁剪并上传图片
    cropAndUpload: function() {
      this.cropper.getCroppedCanvas().toBlob((blob) => {
        const file = new File([blob], "cropped-image.png", { type: "image/png" });
        this.updateImage(URL.createObjectURL(blob), file);
        this.cropVisible = false;
      });
    },

    // 取消裁剪
    cancelCrop: function() {
      this.cropVisible = false;
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
    },

    // 更新图片并上传
    updateImage: function(imageUrl, file) {
      this.$emit('chosen', imageUrl, file);
    },

  }
}
</script>

<style scoped>
</style>
